import { Box, Divider, useMediaQuery } from "@mui/material";

export const BKVRightIcon = () => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_377_46210)">
          <path
            d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z"
            stroke="white"
            stroke-width="2"
            stroke-miterlimit="10"
          />
          <path
            d="M6.26953 11.9997L10.0895 15.8197L17.7295 8.17969"
            stroke="white"
            stroke-width="2"
            stroke-miterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_377_46210">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const BKVCrossIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 22.5C18.299 22.5 23 17.799 23 12C23 6.20101 18.299 1.5 12.5 1.5C6.70101 1.5 2 6.20101 2 12C2 17.799 6.70101 22.5 12.5 22.5Z"
        stroke="#F22824"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M17.2705 7.23438L7.73047 16.7744"
        stroke="#F22824"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M7.73047 7.23438L17.2705 16.7744"
        stroke="#F22824"
        stroke-width="2"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export const InputError = () => {
  const smallSize = useMediaQuery('(max-width:960px)');
  return (
    <svg width={smallSize ? "20" : "24"} height={smallSize ? "20" : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_756_2680)">
        <path d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z" stroke="#F22824" stroke-width="2" stroke-miterlimit="10" />
        <path d="M12 7.17969V12.9097" stroke="#F22824" stroke-width="2" stroke-miterlimit="10" />
        <path d="M12 14.8203V16.7303" stroke="#F22824" stroke-width="2" stroke-miterlimit="10" />
      </g>
      <defs>
        <clipPath id="clip0_756_2680">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const SelectFieldArrow = ({ isOpen, error }) => {
  return (
    <Box sx={{
      position: "relative",
      display: "flex",
    }}>
      {(!isOpen && !error) && <Divider flexItem absolute={true} sx={{ top: 0, left: -10, width: 2, borderRightColor: error ? "red" : "#99D7CF" }} orientation="vertical" />}
      {!error ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 9L12 15L18 9" stroke={"#009A88"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>)
        : <InputError />}
    </Box>
  )
} 
